/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import BtnTryForFree from '@landing_pages/SadhguruExclusive/BtnTryForFree';
import SgXSectionTitle from '@landing_pages/SadhguruExclusive/SgXSectionTitle';
/* Services */

/**
 * Renders the Features component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Features component
 */

const Features = ({ sectionContent, region, language, PackageData }) => {
  const featureData = sectionContent.body.find(
    el => el.sectionId == 'Section-1'
  );
  return (
    <>
      <Box
        as="div"
        display="block"
        textAlign="center"
        mt={{ base: '41px', md: '85px' }}
        sx={{
          h2: { fontSize: '28px', padding: { base: '0 70px', md: 'unset' } },
        }}
      >
        {featureData.sectionContent[3] && (
          <SgXSectionTitle sectionContent={featureData.sectionContent[3]} />
        )}
      </Box>
      <Box
        textAlign="center"
        color="#D0CABA"
        m="16px auto 10px auto"
        fontSize={{ base: '16px', md: '22px' }}
      >
        {featureData.sectionContent[4].text}
      </Box>
      <Box as="div" display="block" mt={{ base: '20px', lg: '75px' }}>
        <Box
          display={{ base: 'block', sm: 'flex' }}
          justifyContent="center"
          margin={{ base: '0 auto', lg: '0px auto 0' }}
          position="relative"
        >
          {featureData?.sectionContent[0]?.simpleCards?.map((el, i) => {
            return (
              <Box
                textAlign="center"
                w={{
                  base: 'auto',
                  sm: 'calc((100% - 60px) / 4)',
                  lg: '329px',
                }}
                marginRight={{ base: '0', lg: '60px' }}
                _last={{ marginRight: '0' }}
              >
                <LazyLoadImageComponent
                  src={el.rectangularImage.url}
                  title={el.rectangularImage.title}
                  alt={el.rectangularImage.alt}
                />
                <Text
                  fontSize={{ base: '24px', sm: '18px', lg: '28px' }}
                  color="#ffffff"
                  p={{ base: '0 15%', sm: '0', md: '0' }}
                  marginTop={{ base: '-65px', sm: 'unset', md: 'unset' }}
                  fontFamily="FedraSansStd-A-medium"
                  className="feature_text"
                >
                  {el.title == '' ? (
                    <>
                      {StructuredTextContent(
                        featureData.sectionContent[1]?.body
                      )}
                    </>
                  ) : (
                    <>{el.title}</>
                  )}
                </Text>
              </Box>
            );
          })}
        </Box>
      </Box>
      {featureData.sectionContent[2] && (
        <Box m="45px 15px 20px 15px" display="block">
          <BtnTryForFree
            sectionContent={featureData.sectionContent[2]}
            region={region}
            language={language}
            PackageData={PackageData}
            eventname="sgx_try_free2_click"
          />
        </Box>
      )}
    </>
  );
};

export default Features;
